export default __webpack_public_path__ + "static/media/octopus-1.8c6d03e2.png";